import { createContext, useContext, useEffect, useState } from "react";

const CmdThemeContext = createContext(null);
const STORAGE_KEY = "cmd_theme";

function resolveInitial() {
  if (typeof window === "undefined") return "light";
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function CmdThemeProvider({ children }) {
  const [theme, setTheme] = useState(resolveInitial);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-cmd-theme", theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return <CmdThemeContext.Provider value={{ theme, toggle }}>{children}</CmdThemeContext.Provider>;
}

export function useCmdTheme() {
  const ctx = useContext(CmdThemeContext);
  if (!ctx) throw new Error("useCmdTheme must be used inside <CmdThemeProvider>");
  return ctx;
}
